<script>
export default {
  name: "IconSpeaker"
};
</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 14" width="19" height="14">
    <g fill="currentColor" fill-rule="nonzero">
      <path
        d="M.67 2.963h4.776L9.62.116a.671.671 0 0 1 1.047.554v12.66a.67.67 0 0 1-1.047.554l-4.175-2.847H.67a.67.67 0 0 1-.67-.67V3.633c0-.37.3-.67.67-.67Zm.67 6.735h4.312c.135 0 .267.04.378.116l3.298 2.25V1.936L6.03 4.186a.67.67 0 0 1-.378.116H1.34v5.396ZM12.073 11.095A4.84 4.84 0 0 0 14.319 7c0-1.666-.84-3.197-2.246-4.095a.67.67 0 1 1 .722-1.129A6.173 6.173 0 0 1 15.659 7a6.172 6.172 0 0 1-2.865 5.225.67.67 0 0 1-.721-1.13Z"
      />
      <path
        d="M15.414 11.095A4.84 4.84 0 0 0 17.66 7c0-1.666-.84-3.197-2.245-4.095a.67.67 0 1 1 .721-1.129A6.173 6.173 0 0 1 19 7a6.172 6.172 0 0 1-2.864 5.225.67.67 0 0 1-.721-1.13Z"
      />
    </g>
  </svg>
</template>
